/* eslint-disable */
import { eventKeyCodes } from './helpers/eventKeyCodes';
/**
 * PopupHandler class is used to manage popup components (PDP).
 */
export class PopupHandler {
  constructor(triggerClass, wrapperClass) {
    this.triggerClass = triggerClass;
    this.wrapperClass = wrapperClass;
    this.init();
  }

  init() {
    const $openPopup = $(`.${this.triggerClass}`);
    const $panelWrapper = $(`.${this.wrapperClass}`);
    const $closePopup = $panelWrapper.find('.panel-close-button');
    const $body = $('body');

    /**
     * Toggle the popup appearance programmatically and adjusts the scrolling behavior of the page.
     * @param {string} [mode='open'] - The mode indicating whether to open or close the popup.
     *  - 'open' (default): Opens the popup by adding the 'panel-wrapper--opened' class and hides overflow.
     *  - 'close': Closes the popup by removing the 'panel-wrapper--opened' class and restores overflow.
     */
    const togglePopup = (mode = 'open') => {
      // Toggle class to open/close the popup
      const isOpen = mode !== 'close';
      $panelWrapper.toggleClass('panel-wrapper--opened', mode !== 'close');
      $body.css('overflow', mode !== 'close' ? 'hidden' : '');

      if (isOpen) {
        setTimeout(() => {
          const $closeButton = $panelWrapper.find('.panel-close-button');
          if ($closeButton.length && $closeButton.is(':visible')) {
            $closeButton.focus();
          }
        }, 50);
      }
    };

    // Open the popup when the trigger element is clicked
    $openPopup.on('click', event => {
      const $clickedElement = $(event.currentTarget);

      let $popupContainer = $(event.target).closest(".js-compare-popup-data");
      if ($popupContainer.length == 1) {
        this.fillComparePopup($popupContainer);
      }

      if (this.triggerClass === 'js-options-item-image-popup') {
        this.fillImagePopup($clickedElement);
      }

      event.preventDefault();
      togglePopup();
    });

    // Close the popup when the close button is clicked and focus trigger element.
    $closePopup.on('click', () => {
      togglePopup('close')
      $openPopup.focus();
    });

    // Close the popup when a click event occurs outside the popup content
    $(document).on('click', event => {
      if ($(event.target).is($panelWrapper)) {
        togglePopup('close');
        $openPopup.focus();
      }
    });

    // Handles the Escape key press to close the currently open popup and focus trigger element.
    $(document).on('keydown', event => {
      if (event.keyCode === eventKeyCodes.escape && $panelWrapper.hasClass('panel-wrapper--opened')) {
        togglePopup('close');
        $openPopup.focus();
      }
    });
  }

  // Checks if the popup is present on the page
  static isOnPage(triggerClass) {
    return $(`.${triggerClass}`).length > 0;
  }

  fillComparePopup(popupContainer) {
    let imgSrc = $(popupContainer).find("input[type=hidden][name=compare-img]").val();
    let title = $(popupContainer).find("input[type=hidden][name=compare-title]").val();
    let description = $(popupContainer).find("input[type=hidden][name=compare-description]").val();
    let img = $('<img>', {
      src: imgSrc,
      'src': imgSrc,
      class: "ls-is-cached",
      loading: "lazy",
      width: 60,
      height: 60
    });

    $(".article-list-item-text .article-list-item-title").html(title);
    $(".article-list-item-text .text-content").html(description);
    $(".article-list-item .article-list-image").html(img);
  }

  /**
   * Populates the popup with image data, descriptions, and dynamic resolution sources based on the clicked element.
   *
   * @param {jQuery} $clickedElement - The jQuery object of the clicked image.
   */
  fillImagePopup($clickedElement) {
    const baseUrl = $clickedElement.attr('data-popup-base-img');
    const imageAlt = $clickedElement.attr('alt');
    const imageDescription = $clickedElement.siblings('.options-item-label').text();

    const descriptions = [
      $clickedElement.attr('data-popup-img-description-first'),
      $clickedElement.attr('data-popup-img-description-second')
    ];

    const $wrapper = $(`.${this.wrapperClass}`);
    const $popupHeaderLabel = $wrapper.find('.panel-header');
    const $popupImage = $wrapper.find('.panel-image');
    const $popupDescriptionLabels = $wrapper.find('.panel-description-label');

    if (baseUrl && $popupImage.length) {

      // Update header Label
      if (imageDescription) {
        $popupHeaderLabel.text(imageDescription);
      }

      // Update values for image
      const srcsetStr = `
        ${baseUrl}?w=643&h=10000&imPolicy=dynamic 643w,
        ${baseUrl}?w=564&h=10000&imPolicy=dynamic 564w,
        ${baseUrl}?w=344&h=10000&imPolicy=dynamic 344w
      `;

      const mainSrc = `${baseUrl}?w=643&h=10000&imPolicy=dynamic`;

      $popupImage.attr({
        'srcset': srcsetStr,
        'src': mainSrc,
        'alt': imageAlt,
        'title': imageAlt,
        'width': '644',
        'height': '320'
      });

      // Update description labels
      descriptions.forEach((text, index) => {
        // Use .eq() to target specific paragraph by index
        const $label = $popupDescriptionLabels.eq(index);
        $label.text(text || '').toggle(!!text);
      });
    }
  }
}

// Initialize the different popups
$(document).ready(() => {
  if (PopupHandler.isOnPage('js-guide-popup')) {
    new PopupHandler('js-guide-popup', 'guide-wrapper');
  }

  if (PopupHandler.isOnPage('js-reviews-popup')) {
    new PopupHandler('js-reviews-popup', 'reviews-wrapper');
  }

  if (PopupHandler.isOnPage('js-question-popup')) {
    new PopupHandler('js-question-popup', 'question-guide-wrapper');
  }

  if (PopupHandler.isOnPage('js-options-item-image-popup')) {
    new PopupHandler('js-options-item-image-popup', 'options-wrapper');
  }
});